import React from 'react';

interface UsePageLockReturn {
  isOpenInAnotherWindow: boolean;
}

export const usePageLock = (pageName = 'default-page'): UsePageLockReturn => {
  const [isOpenInAnotherWindow, setIsOpenInAnotherWindow] =
    React.useState(false);

  React.useEffect(() => {
    const channel = new BroadcastChannel(`page-lock-${pageName}`);

    // When this tab opens, ask if anyone else is there
    channel.postMessage({ type: 'anyone-there?' });

    channel.onmessage = (event) => {
      if (event.data.type === 'anyone-there?') {
        // Another tab is asking, tell them we're here
        channel.postMessage({ type: 'yes-im-here' });
      } else if (event.data.type === 'yes-im-here') {
        // Another tab responded, so we're the duplicate
        setIsOpenInAnotherWindow(true);
      }
    };

    return () => {
      channel.close();
    };
  }, [pageName]);

  return { isOpenInAnotherWindow };
};
